export default "__VITE_ASSET__DEne5IZ3__"